import { API_AUTH } from "./common";

const DanhSachChiDeleteApi = {
  GetDanhSachChiDelete: ({
    name,
    dateFrom,
    dateTo,
    NguoiXoa,
    page,
    pageSize,
  }) => {
    return API_AUTH.get(
      `danh-sach-phieu-chi-bi-xoa?name=${name}&NguoiXoa=${NguoiXoa}&dateFrom=${dateFrom}&dateTo=${dateTo}&page=${page}&pageSize=${pageSize}`,
      {}
    );
  },
  xoaPhieuChiDelete: (Id) => {
    return API_AUTH.delete(`xoa-phieu-chi-bi-xoa?Id=${Id}`, {});
  },
};

export default DanhSachChiDeleteApi;
